import { CompactSelection } from "@glideapps/glide-data-grid";
const contains = (rect, [col, row]) => col >= rect.x && col < rect.x + rect.width && row >= rect.y && row < rect.y + rect.height;
/** Whether the cell is selected, and the range holding it when a range does. */
export const cellSelection = (selection, cell) => {
    const current = selection?.current;
    const range = current && [current.range, ...current.rangeStack].find((rect) => contains(rect, cell));
    const lined = !!selection && (selection.columns.hasIndex(cell[0]) || selection.rows.hasIndex(cell[1]));
    return { selected: !!range || lined, range };
};
export const columnSelection = (selection, col) => selection?.columns.hasIndex(col) ?? false;
/** The selection holding only the cell, or undefined when the cell is already selected. */
export const selectCell = (selection, cell) => cellSelection(selection, cell).selected
    ? undefined
    : {
        columns: CompactSelection.empty(),
        rows: CompactSelection.empty(),
        current: { cell, range: { x: cell[0], y: cell[1], width: 1, height: 1 }, rangeStack: [] },
    };
/** The selection holding only the column, or undefined when the column is already selected. */
export const selectColumn = (selection, col) => columnSelection(selection, col)
    ? undefined
    : { columns: CompactSelection.fromSingleSelection(col), rows: CompactSelection.empty(), current: undefined };
export const clip = (rect, limit) => {
    const width = Math.min(rect.x + rect.width, limit) - rect.x;
    return width > 0 ? { ...rect, width } : undefined;
};
/**
 * The selection kept to the columns left of `limit`: ranges are cut at it, stacked ranges past it
 * dropped, and a cursor past it moves onto the last column inside. Returns `selection` itself when
 * nothing reaches the limit.
 */
export const columnsBefore = (selection, limit) => {
    const { current } = selection;
    const lastColumn = selection.columns?.last();
    const columnsInside = lastColumn === undefined || lastColumn < limit;
    const rangesInside = !current || [current.range, ...current.rangeStack].every((r) => r.x + r.width <= limit);
    if (columnsInside && rangesInside)
        return selection;
    const last = limit - 1;
    const columns = columnsInside ? selection.columns : selection.columns.remove([limit, Number.MAX_SAFE_INTEGER]);
    if (!current)
        return { ...selection, columns };
    const cell = [Math.min(current.cell[0], last), current.cell[1]];
    const range = clip(current.range, limit) ?? { x: last, y: current.range.y, width: 1, height: current.range.height };
    const rangeStack = current.rangeStack.flatMap((r) => clip(r, limit) ?? []);
    return { ...selection, columns, current: { ...current, cell, range, rangeStack } };
};
//# sourceMappingURL=selection.js.map